import React from "react";
// import imagesjpg from "../upload/images.jpg";
// import imagespng from "../upload/images.png";
import facebook from "../images/social/facebook-filled.png";
import instagram from "../images/social/instagram-filled.png";
import tiktok from "../images/social/tiktok-filled.png";
import twitterx from "../images/social/twitterx-filled.png";
import youtube from "../images/social/youtube-filled.png";
import sciever from "../images/social/scieverinc.png";
import useMobile from "../hooks/useMobile";
// import { Link } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { scroller } from "react-scroll";

const Footer = () => {
  const mobile = useMobile();
  const { setLoading } = useLoader();
  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  const { companyDetailsData } = useCompanyDetailsContext();
  const logo = `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color[0]?.media?.url}`;
  const companyAddress = companyDetailsData[0]?.company_address || "";

  return (
    <>
      <div id="footer_wrapper">
        <div id="footer" className=" ">
          <div className="logo_container">
            <div className="logo_align">
              <a className="logo_wrapper default" href="/">
                <img src={logo} alt="logo" height="160" />
              </a>
            </div>
          </div>

          <ul className="sidebar_widget four">
            <li id="text-3" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Our Address</span>
              </h2>
              <div className="textwidget">
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <div className="custom-footer-icon">
                    <span className="ti-home"></span>
                    <strong>{companyDetailsData[0]?.company_name}</strong>
                    <br />
                  </div>
                  <div className="custom-footer-icon">
                    <span className="ti-location-pin"></span>
                    {companyAddress}
                  </div>
                  {/* <br /> */}
                </p>
              </div>
            </li>
            <li id="text-4" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Reservation</span>
              </h2>
              <div className="textwidget">
                <p>
                  <div
                    className="custom-footer-icon"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <span className="ti-mobile"></span>
                    <a
                      className="tooltip"
                      href={`tel:${companyDetailsData[0]?.mobile_number}`}
                      title="Call Us"
                    >
                      {companyDetailsData[0]?.mobile_number}
                    </a>
                    {companyDetailsData[0]?.mobile_number &&
                      companyDetailsData[0]?.telephone_number && (
                        <span
                          className="ti-layout-line-solid"
                          style={{
                            display: "inline-block",
                            transform: "rotate(90deg)",
                            marginRight: "unset",
                          }}
                        ></span>
                      )}
                    <a
                      className="tooltip"
                      href={`tel:${companyDetailsData[0]?.telephone_number}`}
                      title="Call Us"
                    >
                      {companyDetailsData[0]?.telephone_number}
                    </a>
                  </div>
                  <br />
                  <div className="custom-footer-icon">
                    <span className="ti-email"></span>
                    <a
                      className="tooltip"
                      href={`mailto:${companyDetailsData[0]?.email}`}
                      title="Email Us"
                    >
                      {companyDetailsData[0]?.email}
                    </a>
                  </div>
                </p>
              </div>
            </li>
            <li id="text-12" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Social Media</span>
              </h2>
              <div className="socialwidget">
                <p>
                  {companyDetailsData[0]?.facebook_link && (
                    <a
                      href={companyDetailsData[0]?.facebook_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-860 alignnone"
                        src={facebook}
                        alt="facebook"
                        width="118"
                        height="106"
                      />
                    </a>
                  )}
                  {companyDetailsData[0]?.instagram_link && (
                    <a
                      href={companyDetailsData[0]?.instagram_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={instagram}
                        alt="instagram"
                        width="102"
                        height="123"
                      />
                    </a>
                  )}
                  {companyDetailsData[0]?.twitterx_link && (
                    <a
                      href={companyDetailsData[0]?.twitterx_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={twitterx}
                        alt="twitterx"
                        width="102"
                        height="123"
                      />
                    </a>
                  )}
                  {companyDetailsData[0]?.tiktok_link && (
                    <a
                      href={companyDetailsData[0]?.tiktok_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={tiktok}
                        alt="tiktok"
                        width="102"
                        height="123"
                      />
                    </a>
                  )}
                  {companyDetailsData[0]?.youtube_link && (
                    <a
                      href={companyDetailsData[0]?.youtube_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={youtube}
                        alt="youtube"
                        width="102"
                        height="123"
                      />
                    </a>
                  )}
                </p>
              </div>
            </li>
            {/* <li id="text-12" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Awards</span>
              </h2>
              <div className="textwidget">
                <p>
                  <img
                    className="size-full wp-image-860 alignnone"
                    src={imagesjpg}
                    alt="awards"
                    width="118"
                    height="106"
                  />
                  <img
                    className="size-full wp-image-861 alignnone"
                    src={imagespng}
                    alt="awards"
                    width="102"
                    height="123"
                  />
                </p>
              </div>
            </li> */}
          </ul>
        </div>

        <div className="footer_bar">
          <div className="footer_bar_wrapper">
            <div className="menu-footer-menu-container">
              <ul id="footer_menu" className="footer_nav">
                <li className="menu-item">
                  <a
                    href="/"
                    aria-current="page"
                    onClick={() => linkClicker("")}
                  >
                    Home
                  </a>
                </li>
                <li className="menu-item">
                  <a href="/our-rooms" onClick={() => linkClicker("our-rooms")}>
                    Our Rooms
                  </a>
                </li>
                <li className="menu-item">
                  <a href="/aboutus" onClick={() => linkClicker("aboutus")}>
                    About Us
                  </a>
                </li>
                <li className="menu-item">
                  <a href="/contact" onClick={() => linkClicker("contact")}>
                    Contact
                  </a>
                </li>
                <li className="menu-item">
                  <a href="/gallery" onClick={() => linkClicker("gallery")}>
                    Gallery
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="/terms-and-condition"
                    onClick={() => linkClicker("terms-and-condition")}
                  >
                    Terms and Conditions
                  </a>
                </li>
              </ul>
            </div>
            <div
              id="copyright"
              style={{
                display: "inline-flex",
                flexWrap: mobile ? "wrap" : "unset",
                flexDirection: mobile ? "column" : "unset",
              }}
            >
              <div>
                ©&nbsp;Copyright&nbsp;
                <a href="/">{companyDetailsData[0]?.company_name}</a>
              </div>
              <div>
                {!mobile ? <>&nbsp;-&nbsp;</> : ""}Powered&nbsp;by&nbsp;
                <a
                  href="https://www.scieverinc.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={sciever} alt="sciever" />
                  &nbsp;Sciever&nbsp;Inc.
                </a>
              </div>
            </div>
            <br className="clear" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
